import VehiclesReservationsTable from 'src/features/reservations/components/tables/VehiclesReservationsTable';

const Reservations = () => {
    return <VehiclesReservationsTable />;
};

export default Reservations;
